import React, { Component } from "react";
import Navbar from "@/modules/Navbar";
import Banner from "@/modules/Banner";
import Description from "@/modules/Description";
import CardListWithTitle from "@/modules/CardListWithTitle";
import CardList from "@/modules/CardList";
import Theme from "@/modules/Theme";
import Submission from "@/modules/Submission";
import Prizes from "@/modules/Prizes";
import Timeline from "@/modules/Timeline";
import Finalists from "@/modules/Finalists";
import Partners from "@/modules/Partners";
import Faq from "@/modules/Faq";
import Contact from "@/modules/Contact";
import Footer from "@/modules/Footer";
import { Helmet } from "react-helmet";
import MessageEn from '@/constants/messageEn'
import "@/scss/App.scss";
import { $t, createTranslator } from '@/modules/i18n';

class Application extends React.Component {
  constructor(props) {
    super(props);
    this.url = "https://careers.shopee.sg/productdesign2021";
    this.imageURL =
      "https://careers.shopee.sg/productdesign2021/images/cover.png";
  }

  render() {
    const { message = {} } = this.props;
    return (
      <div className="application">
        <Helmet
          title={$t(message.title)}
          titleAttribute={{ itemprop: "name", lang: "en" }}
          meta={[
            { name: "description", content: $t(message.desc) },
            { name: "robots", content: "index, follow" },
            { property: "og:title", content: $t(message.title) },
            { property: "og:type", content: "website" },
            { property: "og:url", content: this.url },
            { property: "og:image", content: this.imageURL },
            { property: "og:description", content: $t(message.desc) }
          ]}
          link={[{ rel: "canonical", href: this.url }]}
          script={[
            {
              type: "application/ld+json",
              innerHTML: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Event",
                name: $t(message.title),
                description: $t(message.desc),
                image: this.imageURL,
                startDate: $t(message.startDate),
                endDate: $t(message.endDate),
                url: this.url,
                audience: {
                  audienceType:
                    "Students and Professionals passionate about Data!",
                  "@type": "EducationalAudience",
                },
                location: {
                  "@type": "Place",
                  name: "Shopee Singapore",
                  address: "Online",
                }
              })
            }
          ]}
        />
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: {}
    }
  }

  componentWillMount() {
    console.log('process', process.env.REACT_APP_COUNTRY)
    createTranslator().then(res => {
      this.setState({
        message: MessageEn
      })
    })
  }
  render() {
    let Message = this.state.message;

    return (
      <div className="App">
        <Application message={Message.application} />
        <Navbar message={Message.navbar} />
        <Banner message={Message.banner} className="card-theme" />
        <Description message={Message.about} id="about">
          <p className="highlight subtitle">{$t((Message.about || {}).highlight)}</p>
        </Description>
        <section className="iconText">
          {
            ((Message.about || {}).iconText || []).map(item => (
              <div key={item} className="item">{$t(item)}</div>
            ))
          }
        </section>
        <section id="card-list" className="card-theme">
          <CardList list={Message.cardList} />
        </section>
        <Description message={Message.objectives} id="objectives">
          <p className="text">{$t((Message.objectives || {}).text)}</p>
        </Description>
        <CardListWithTitle id="categories" message={Message.categories} />
        <Theme message={Message.theme} className="card-theme" />
        <CardListWithTitle id="judge" message={Message.judge} />
        <Submission message={Message.submission} />
        <Timeline message={Message.timeline} />
        <Prizes message={Message.prizes} className="card-theme" />
        <Description message={Message.training} id="training" />
        <Finalists message={Message.finalists} />
        <Faq message={Message.faq} />
        <Partners message={Message.partners} />
        <Contact message={Message.contact} />
        <Footer message={Message.footer} />
      </div>
    );
  }
}

export default App;
